<template>
  <div>
    <Menu />
    <pulse-loader
      :loading="loading"
      :color="color"
      :size="size"
      class="vue-loader"
    ></pulse-loader>

    <div
      class="container main"
      v-if="id_funcao == 2 || id_funcao == 1 || id_funcao == 7"
    >
      <div class="row">
        <div class="col-md-12">
          <SectionTitle
            title="Gerenciar permissões"
            description="Selecione quais páginas devem estar visíveis para os usuários"
            url="/administracao"
            modalDocument="DocGerenciarPermissoes"
          />
        </div>
      </div>

      <div class="row">
        <div class="col-md-12">
          <div class="accordion" role="tablist" id="accordion-permissions">
            <PermissionAccordion
              v-for="profile in profileList"
              :key="profile.id"
              :title="profile.title"
              :accordion-id="profile.accordionId"
              :accordion-group="profile.accordionGroup"
              :pages="profile.pages"
              :permissionsData="profile.permissionsData"
              :permissions="profile.permissions"
              :onSave="salvarPermissoes"
              :roleId="profile.id"
              :loading="loading"
            />
          </div>
        </div>
      </div>
    </div>

    <Footer />
  </div>
</template>

<script>
import Menu from '@/components/Menu'
import Footer from '@/components/Footer'
import SectionTitle from '@/components/SectionTitle'
import { permissoes } from '@/services/Permissoes.js'
import utils from '@/mixins/utils.js'
import PulseLoader from 'vue-spinner/src/PulseLoader.vue'
import { mapState } from 'vuex'
import PermissionAccordion from './components/PermissionAccordion.vue'

const profileDefinitions = [
  {
    id: 3,
    slug: 'acs',
    title: 'Agente Comunitário de Saúde',
    accordionId: 'accordion-1',
    accordionGroup: 'my-accordion-1',
    pages: [
      { key: 'dashboard', value: 'Página inicial' },
      { key: 'gestao_cadastros', value: 'Gestão cadastros' },
      { key: 'visitas_domiciliares', value: 'Visitas domiciliares' },
      { key: 'imunizacao', value: 'Imunização' },
      { key: 'vacina_idade_certa', value: 'Vacina idade certa' },
      { key: 'indicadores_aps', value: 'Indicadores APS' },
      { key: 'esf_eap', value: 'eSF / eAP' },
      { key: 'emulti', value: 'eMulti' },
      { key: 'indicadores_esb', value: 'eSB' },
      { key: 'saude_bucal', value: 'Saúde bucal' },
      { key: 'vinculo_acompanhamento', value: 'Vínculo e Acompanhamento' },
      { key: 'oficinas_treinamentos', value: 'Oficinas Reuniões Treinamentos' },
    ],
  },
  {
    id: 6,
    slug: 'auxEnfermagem',
    title: 'Aux/Téc Enfermagem',
    accordionId: 'accordion-2',
    accordionGroup: 'my-accordion-2',
    pages: [
      { key: 'dashboard', value: 'Página inicial' },
      { key: 'gestao_cadastros', value: 'Gestão cadastros' },
      { key: 'imunizacao', value: 'Imunização' },
      { key: 'vacina_idade_certa', value: 'Vacina idade certa' },
      { key: 'divergencia_vacinas', value: 'Divergência vacinas' },
      { key: 'indicadores_aps', value: 'Indicadores APS' },
      { key: 'esf_eap', value: 'eSF / eAP' },
      { key: 'emulti', value: 'eMulti' },
      { key: 'indicadores_esb', value: 'eSB' },
      { key: 'saude_bucal', value: 'Saúde bucal' },
      { key: 'vinculo_acompanhamento', value: 'Vínculo e Acompanhamento' },
      { key: 'oficinas_treinamentos', value: 'Oficinas Reuniões Treinamentos' },
      { key: 'upa', value: 'UPA' },
    ],
  },
  {
    id: 4,
    slug: 'enfermeiroMedico',
    title: 'Enfermeiro(a) / Médico(a)',
    accordionId: 'accordion-3',
    accordionGroup: 'my-accordion-3',
    pages: [
      { key: 'dashboard', value: 'Página inicial' },
      { key: 'gestao_cadastros', value: 'Gestão cadastros' },
      { key: 'imunizacao', value: 'Imunização' },
      { key: 'vacina_idade_certa', value: 'Vacina idade certa' },
      { key: 'divergencia_vacinas', value: 'Divergência vacinas' },
      { key: 'indicadores_aps', value: 'Indicadores APS' },
      { key: 'esf_eap', value: 'eSF / eAP' },
      { key: 'emulti', value: 'eMulti' },
      { key: 'indicadores_esb', value: 'eSB' },
      { key: 'saude_bucal', value: 'Saúde bucal' },
      { key: 'vinculo_acompanhamento', value: 'Vínculo e Acompanhamento' },
      { key: 'oficinas_treinamentos', value: 'Oficinas Reuniões Treinamentos' },
      { key: 'upa', value: 'UPA' },
    ],
  },
  {
    id: 8,
    slug: 'odontologo',
    title: 'Odontólogo(a)',
    accordionId: 'accordion-4',
    accordionGroup: 'my-accordion-4',
    pages: [
      { key: 'dashboard', value: 'Página inicial' },
      { key: 'gestao_cadastros', value: 'Gestão cadastros' },
      { key: 'indicadores_aps', value: 'Indicadores APS' },
      { key: 'esf_eap', value: 'eSF / eAP' },
      { key: 'emulti', value: 'eMulti' },
      { key: 'indicadores_esb', value: 'eSB' },
      { key: 'saude_bucal', value: 'Saúde bucal' },
      { key: 'vinculo_acompanhamento', value: 'Vínculo e Acompanhamento' },
      { key: 'oficinas_treinamentos', value: 'Oficinas Reuniões Treinamentos' },
      { key: 'upa', value: 'UPA' },
    ],
  },
  {
    id: 5,
    slug: 'recepcionista',
    title: 'Recepcionista',
    accordionId: 'accordion-5',
    accordionGroup: 'my-accordion-5',
    pages: [
      { key: 'dashboard', value: 'Página inicial' },
      { key: 'gestao_cadastros', value: 'Gestão cadastros' },
      { key: 'indicadores_aps', value: 'Indicadores APS' },
      { key: 'esf_eap', value: 'eSF / eAP' },
      { key: 'emulti', value: 'eMulti' },
      { key: 'indicadores_esb', value: 'eSB' },
      { key: 'saude_bucal', value: 'Saúde bucal' },
      { key: 'vinculo_acompanhamento', value: 'Vínculo e Acompanhamento' },
      { key: 'oficinas_treinamentos', value: 'Oficinas Reuniões Treinamentos' },
      { key: 'upa', value: 'UPA' },
    ],
  },
  {
    id: 7,
    slug: 'coordenador',
    title: 'Gerente/Coordenador(a)',
    accordionId: 'accordion-6',
    accordionGroup: 'my-accordion-6',
    pages: [
      { key: 'dashboard', value: 'Página inicial' },
      { key: 'gestao_cadastros', value: 'Gestão cadastros' },
      { key: 'visitas_domiciliares', value: 'Visitas domiciliares' },
      { key: 'imunizacao', value: 'Imunização' },
      { key: 'vacina_idade_certa', value: 'Vacina idade certa' },
      { key: 'indicadores_aps', value: 'Indicadores APS' },
      { key: 'esf_eap', value: 'eSF / eAP' },
      { key: 'emulti', value: 'eMulti' },
      { key: 'indicadores_esb', value: 'eSB' },
      { key: 'saude_bucal', value: 'Saúde bucal' },
      { key: 'vinculo_acompanhamento', value: 'Vínculo e Acompanhamento' },
      { key: 'bpa_e_ras', value: 'BPA E RAAS' },
      { key: 'oficinas_treinamentos', value: 'Oficinas Reuniões Treinamentos' },
      { key: 'upa', value: 'UPA' },
    ],
  },
  {
    id: 13,
    slug: 'vacinador',
    title: 'Vacinador(a)',
    accordionId: 'accordion-7',
    accordionGroup: 'my-accordion-7',
    pages: [
      { key: 'dashboard', value: 'Página inicial' },
      { key: 'gestao_cadastros', value: 'Gestão cadastros' },
      { key: 'imunizacao', value: 'Imunização' },
      { key: 'vacina_idade_certa', value: 'Vacina idade certa' },
      { key: 'divergencia_vacinas', value: 'Divergência vacinas' },
      { key: 'indicadores_aps', value: 'Indicadores APS' },
      { key: 'esf_eap', value: 'eSF / eAP' },
      { key: 'emulti', value: 'eMulti' },
      { key: 'indicadores_esb', value: 'eSB' },
      { key: 'saude_bucal', value: 'Saúde bucal' },
      { key: 'oficinas_treinamentos', value: 'Oficinas Reuniões Treinamentos' },
      { key: 'upa', value: 'UPA' },
    ],
  },
  {
    id: 14,
    slug: 'tecSaudeBucal',
    title: 'Téc. Aux de Saúde Bucal',
    accordionId: 'accordion-8',
    accordionGroup: 'my-accordion-8',
    pages: [
      { key: 'dashboard', value: 'Página inicial' },
      { key: 'indicadores_aps', value: 'Indicadores APS' },
      { key: 'esf_eap', value: 'eSF / eAP' },
      { key: 'emulti', value: 'eMulti' },
      { key: 'indicadores_esb', value: 'eSB' },
      { key: 'saude_bucal', value: 'Saúde bucal' },
      { key: 'vinculo_acompanhamento', value: 'Vínculo e Acompanhamento' },
      { key: 'oficinas_treinamentos', value: 'Oficinas Reuniões Treinamentos' },
      { key: 'upa', value: 'UPA' },
    ],
  },
  {
    id: 10,
    slug: 'ace',
    title: 'ACE (Agente Comunitário de Endemias)',
    accordionId: 'accordion-9',
    accordionGroup: 'my-accordion-9',
    pages: [
      { key: 'dashboard', value: 'Página inicial' },
      { key: 'gestao_cadastros', value: 'Gestão cadastros' },
      { key: 'oficinas_treinamentos', value: 'Oficinas Reuniões Treinamentos' },
      { key: 'upa', value: 'UPA' },
    ],
  },
  {
    id: 12,
    slug: 'coordenadorImunizacao',
    title: 'Coordenador(a) de Imunização',
    accordionId: 'accordion-10',
    accordionGroup: 'my-accordion-10',
    pages: [
      { key: 'dashboard', value: 'Página inicial' },
      { key: 'gestao_cadastros', value: 'Gestão cadastros' },
      { key: 'imunizacao', value: 'Imunização' },
      { key: 'vacina_idade_certa', value: 'Vacina idade certa' },
      { key: 'divergencia_vacinas', value: 'Divergência vacinas' },
      { key: 'indicadores_aps', value: 'Indicadores APS' },
      { key: 'esf_eap', value: 'eSF / eAP' },
      { key: 'emulti', value: 'eMulti' },
      { key: 'indicadores_esb', value: 'eSB' },
      { key: 'saude_bucal', value: 'Saúde bucal' },
      { key: 'oficinas_treinamentos', value: 'Oficinas Reuniões Treinamentos' },
      { key: 'upa', value: 'UPA' },
    ],
  },
  {
    id: 11,
    slug: 'coordenadorVigilanciaSaude',
    title: 'Coordenador(a) de Vigilância em Saúde',
    accordionId: 'accordion-11',
    accordionGroup: 'my-accordion-11',
    pages: [
      { key: 'dashboard', value: 'Página inicial' },
      { key: 'gestao_cadastros', value: 'Gestão cadastros' },
      { key: 'oficinas_treinamentos', value: 'Oficinas Reuniões Treinamentos' },
      { key: 'upa', value: 'UPA' },
    ],
  },
  {
    id: 9,
    slug: 'farmaciaOutros',
    title: 'Fármacia e outros',
    accordionId: 'accordion-12',
    accordionGroup: 'my-accordion-12',
    pages: [
      { key: 'dashboard', value: 'Página inicial' },
      { key: 'gestao_cadastros', value: 'Gestão cadastros' },
      { key: 'oficinas_treinamentos', value: 'Oficinas Reuniões Treinamentos' },
      { key: 'upa', value: 'UPA' },
    ],
  },
  {
    id: 15,
    slug: 'profissionalEmulti',
    title: 'Profissional da eMulti',
    accordionId: 'accordion-13',
    accordionGroup: 'my-accordion-13',
    pages: [
      { key: 'dashboard', value: 'Página inicial' },
      { key: 'gestao_cadastros', value: 'Gestão cadastros' },
      { key: 'indicadores_aps', value: 'Indicadores APS' },
      { key: 'emulti', value: 'eMulti' },
      { key: 'vinculo_acompanhamento', value: 'Vínculo e Acompanhamento' },
      { key: 'oficinas_treinamentos', value: 'Oficinas Reuniões Treinamentos' },
      { key: 'upa', value: 'UPA' },
    ],
  },
]

function generateEmptyPermissions(keys) {
  return keys.reduce((acc, key) => {
    acc[key] = []
    return acc
  }, {})
}

function buildProfilesState() {
  return profileDefinitions.reduce((acc, profile) => {
    const keys = profile.pages.map((page) => page.key)

    acc[profile.slug] = {
      ...profile,
      permissions: generateEmptyPermissions(keys),
      permissionsData: generateEmptyPermissions(keys),
    }

    return acc
  }, {})
}

export default {
  metaInfo: {
    title: 'Gerenciar permissões',
    titleTemplate: null,
  },
  components: {
    Menu,
    Footer,
    SectionTitle,
    PulseLoader,
    PermissionAccordion,
  },
  mixins: [utils],
  data() {
    return {
      profiles: buildProfilesState(),
      loading: false,
      size: '40px',
      color: '#0D98BB',
    }
  },
  computed: {
    ...mapState(['id_funcao']),
    profileList() {
      return Object.values(this.profiles)
    },
  },
  mounted() {
    this.buscarPermissoes()
  },
  methods: {
    /**
     * Buscar permissões por município
     */
    async buscarPermissoes() {
      try {
        this.loading = true

        const response = await this.$api.get(
          `/app/permissoes/${this.$store.state.cod_ibge}`
        )

        if (!response || !response.data) {
          return
        }

        this.resetProfilesState()

        this.profileList.forEach((profile) => {
          const perfilData = response.data.filter(
            (item) => Number(item.id_perfil) === Number(profile.id)
          )

          profile.pages.forEach((page) => {
            this.addCard(perfilData, profile.slug, page.key)
          })
        })
      } catch (error) {
        console.error('Erro ao buscar permissões:', error)
      } finally {
        this.loading = false
      }
    },

    /**
     * Reseta o estado dos perfis
     */
    resetProfilesState() {
      this.profileList.forEach((profile) => {
        const keys = profile.pages.map((page) => page.key)
        profile.permissions = generateEmptyPermissions(keys)
        profile.permissionsData = generateEmptyPermissions(keys)
      })
    },

    /**
     * Adiciona um card ao perfil
     * @param permissoesApi
     * @param profileSlug
     * @param permissionKey
     */
    addCard(permissoesApi, profileSlug, permissionKey) {
      if (!permissoesApi || !permissoesApi.length) {
        return
      }

      const profile = this.profiles[profileSlug]
      if (!profile) {
        return
      }

      const permissoesData = permissoes.find(
        (item) => Number(item.id_perfil) === Number(profile.id)
      )

      if (
        !permissoesData ||
        !permissoesData[permissionKey] ||
        !Array.isArray(permissoesData[permissionKey])
      ) {
        return
      }

      const apiItem = permissoesApi[0]
      if (!apiItem) {
        return
      }

      for (const key in apiItem) {
        const val = permissoesData[permissionKey].find(
          (item) => item.key === key
        )

        if (val) {
          profile.permissionsData[permissionKey].push(val)

          if (apiItem[key] == '1') {
            profile.permissions[permissionKey].push(val)
          }
        }
      }
    },

    /**
     * Salva as permissões
     * @param {number} idPerfil
     */
    async salvarPermissoes(idPerfil) {
      try {
        this.loading = true

        const profile = this.profileList.find(
          (item) => Number(item.id) === Number(idPerfil)
        )

        if (!profile) {
          return
        }

        const payload = this.formatPayload(
          profile.permissions,
          profile.permissionsData
        )

        const response = await this.$api.post(
          `/app/permissoes/${this.$store.state.cod_ibge}/${idPerfil}`,
          {
            payload,
          }
        )

        if (response) {
          if (response.data.error == false) {
            this.$toast.success(
              `Permissões para o perfil: ${profile.title} alteradas com sucesso!`,
              'Sucesso:',
              {
                position: 'topRight',
              }
            )
          } else {
            this.$toast.error(response.data.message, 'Error:', {
              position: 'topRight',
            })
          }
        }
      } catch (error) {
        console.log(error)
      } finally {
        this.loading = false
      }
    },

    /**
     * Formata o payload para salvar as permissões
     * @param permissoesEnable
     * @param permissoesData
     */
    formatPayload(permissoesEnable, permissoesData) {
      let permissoesDisabled = []

      if (!this.deepEqual(permissoesEnable, permissoesData)) {
        for (const key in permissoesEnable) {
          const difference = permissoesEnable[key]
            .filter((x) => !permissoesData[key].includes(x))
            .concat(
              permissoesData[key].filter(
                (x) => !permissoesEnable[key].includes(x)
              )
            )

          if (difference.length > 0) {
            permissoesDisabled.push(...difference)
          }
        }
      }

      return {
        enable: JSON.stringify(permissoesEnable),
        disable: JSON.stringify(permissoesDisabled),
      }
    },
  },
}
</script>

<style></style>
